import { createContext, useState } from 'react';
import { useParams, useHistory, useLocation } from 'react-router';
import { parse } from 'querystring-es3';

import get from 'lodash/get';
import ComponentOutlet from './ComponentOutlet';
import EditorDetector from './EditorDetector';
import getPage from '../../api/storyblok';
import Loader from '../helper/Loader';
import Page from '../storyblok/Page';
import StoryblokData from './StoryblokData';

function useQuery() {
	return parse(useLocation().search.substr(1));
}

const pageTypes = ['page', 'default-page', 'Page'];

export const StoryblokPageCtx = createContext({});
function StoryblokPage({ page }) {
	const history = useHistory();
	const params = useParams();
	const location = useLocation();
	const query = useQuery();
	const [pageOverride, setPageOverride] = useState();

	return (
		<Loader services={() => [getPage(page)]} required={[page]} unmountOnExit={false}>
			{({ results, reload, setResults }) => {
				const data = pageOverride || results[0];
				const content = get(data, 'content');
				if (!content) return null;

				const { body, layout, facebookTrack } = content;
				function setPage(newData) {
					const newRes = [{ ...results[0], data: newData }];
					setResults(newRes);
					if (data.uuid === newData.uuid) setPageOverride(newData);
				}

				const isPage = pageTypes.includes(content.component);

				return (
					<StoryblokPageCtx.Provider value={{ page: data, reload, setPage }}>
						<EditorDetector />
						<StoryblokData
							data={{
								window,
								windowLocation: window.location,
								params,
								query,
								history,
								location,
							}}
						>
							{isPage && (
								<Page
									facebookTrack={facebookTrack}
									full_slug={data.full_slug}
									body={body}
									layout={layout}
								/>
							)}
							{!isPage && <ComponentOutlet components={content} />}
						</StoryblokData>
					</StoryblokPageCtx.Provider>
				);
			}}
		</Loader>
	);
}

// const resolver = (prevProps, nextProps) => prevProps.page === nextProps.page;
// export default React.memo(StoryblokPage, resolver);
export default StoryblokPage;
